// D-0123 (Rafael 28/10): boleto da parcela no Efetivo — anexar, ver, baixar e excluir.
// Quem exclui: Eventos e Financeiro (+ admin/diretor); parcela paga, só admin/diretor.
// Mesma regra da API (BoletoParcelaPolicy.php); aqui só avisa e desabilita o botão.
import React from 'react';
import { FaFileInvoiceDollar } from 'react-icons/fa';

export const PERFIS_EXCLUIR_BOLETO = [
    'evento', 'gerenteevento', 'gerenteeventointernacional',
    'financeiro', 'gerentefinanceiro', 'financeiro.adiantamento', 'financeiro.credito',
    'admin', 'diretor',
];

export const AVISO_SEM_PERMISSAO_BOLETO = 'Só Eventos e Financeiro (ou admin/diretor) excluem o boleto.';

export const MSG_BOLETO_SEM_VINCULO = 'O boleto pode ser anexado depois que o Financeiro aprovar o plano. Até lá, informe a linha digitável.';

// Tipo para o DocumentosParcela (lista, abrir, substituir e excluir com histórico).
export const TIPOS_DOC_BOLETO = [
    { key: 'boleto', rotulo: 'Boleto', icone: <FaFileInvoiceDollar size={13} />, pasta: 'boleto' },
];

export function podeExcluirBoleto(perfil) {
    return PERFIS_EXCLUIR_BOLETO.includes(String(perfil || '').trim().toLowerCase());
}

// Campos que o servidor manda sobre o boleto/vínculo da parcela — o que a linha do Efetivo
// precisa para anexar e mostrar o boleto.
export function camposBoletoDe(p) {
    return {
        financeiroparcela_id: (p && p.financeiroparcela_id) || null,
        boleto_anexado: !!(p && p.boleto_anexado),
        boleto_nome: (p && p.boleto_nome) || null,
        boleto_arquivo_id: (p && p.boleto_arquivo_id) || null,
        travado_pagamento: !!(p && p.travado_pagamento),
    };
}

// O recarregar mantém as linhas do Efetivo (não perde o que o operador digitou), mas o boleto
// e o vínculo mudam no servidor (anexou, excluiu, Financeiro aprovou/travou): copia só esses
// campos. Sem isto a tela dizia "Boleto anexado!" e a linha seguia em "Anexar boleto" até o F5.
// Linha salva casa pelo id (parcelas_efetivo); linha ainda não salva, pela parcela da previsão.
export function sincronizarBoletoNasParcelas(parcelas, fornecedor) {
    const porEfetivo = new Map((fornecedor.parcelas_efetivo || []).map(p => [String(p.id), p]));
    const porPrevisao = new Map((fornecedor.parcelas_aprovadas || fornecedor.parcelas || []).map(p => [String(p.id), p]));
    return (parcelas || []).map(p => {
        const fonte = (p.id && porEfetivo.get(String(p.id)))
            || (p.previsao_parcela_id && porPrevisao.get(String(p.previsao_parcela_id)));
        return fonte ? { ...p, ...camposBoletoDe(fonte) } : p;
    });
}
